import { FC } from 'react';

type BrokerOfficeIconProps = {
  width?: number | string;
  height?: number | string;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const BrokerOfficeIcon: FC<BrokerOfficeIconProps> = ({
  width = 48,
  height = 48,
  color = '#D25D3E',
  ...rest
}) => (
  <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M6 24V34M6 34H10C12.8284 34 14.2426 34 15.1213 34.8786C16 35.7574 16 37.1716 16 40V42M6 34V42" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 14L18.6334 8.1669C21.2668 6.7223 22.5836 6 24 6C25.4164 6 26.7332 6.7223 29.3666 8.1669L40 14" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M36 12V20M12 12V20" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M42 24V34M42 34H38C35.1716 34 33.7574 34 32.8786 34.8786C32 35.7574 32 37.1716 32 40V42M42 34V42" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 28H24M24 28H34M24 28V42M24 42H22M24 42H26" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
